import { MarkerType } from "@xyflow/react";
import { Colors } from "@zapier/design-system";

export const MARKER = {
  type: MarkerType.Arrow,
  strokeWidth: 1.5,
  color: Colors.GrayWarm9,
};

export const SELECTED_MARKER = {
  type: MarkerType.Arrow,
  strokeWidth: 1.5,
  color: Colors.UiPrimaryStronger,
};

export const SUGGESTION = "suggestion";
